<div class="usan-form-item cover-letter-container">
  <div class="usan-checklist-item">
    <div class="usan-checklist-icon-column">
      <mat-icon>{{ hasCoverLetterFile ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
    </div>
    <div class="usan-checklist-content-column">
      <span class="usan-form-item cover-letter-item cover-letter-text">
        Cover Letter (recommended)
        <ul>
          <li *ngIf="!isFormDType">Explanation of the action and use of your substance</li>
          <li *ngIf="!isFormDType">Explanation of why the USAN stem suggested was chosen for your substance</li>
          <li *ngIf="isFormDType">Please explain in a cover letter the reason(s) for requesting a revision to adoption information</li>
        </ul>
      </span>
    </div>
  </div>
  <div class="usan-form-item button-layout layout-centered">
    <button type="button" class="upload-cover-letter form-btn form-btn-style form-btn-text" (click)="openDialog()">
      <mat-icon class="form-btn-icon">upload</mat-icon>
      Upload cover letter
    </button>
  </div>
  <ng-container *ngIf="hasCoverLetterFile">
    <div class="full-width" *ngFor="let file of attachments">
      <app-uploaded-file [requiresAdmin]="false" [attachment]="file"></app-uploaded-file>
    </div>
  </ng-container>
</div>